import { Component, input, Input, InputSignal, Signal } from '@angular/core';
import {
  PurposeControlType,
  RoadOccupationForm,
  WorkPurposeControlType
} from '../../forms/road-occupation.form';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { StageFormComponent } from '../stage-form/stage-form.component';
import { Store } from '@ngrx/store';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';
import { TabViewComponent } from '../../../../../../../common/tab-view/tab-view.component';
import { TabPanelComponent } from '../../../../../../../common/tab-view/tab-panel.component';
import {
  RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee,
  RoadOccupationTypeAppEntityDictionaryRoadOccupationType
} from '../../../../../../../openapi';
import {
  selectPurposeFeeCollection,
  selectRoadOccupationTypes
} from '../../../../../../../store/selectors/application.selectors';
import { DpDatePickerModule } from 'ng2-date-picker';
import {
  LocationDecisionsCrudComponent
} from '../../../components/location-decisions/location-decisions-crud/location-decisions-crud.component';

@Component({
  selector: 'app-road-occupation-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    TabViewComponent,
    TabPanelComponent,
    StageFormComponent,
    DpDatePickerModule,
    LocationDecisionsCrudComponent
  ],
  templateUrl: './road-occupation-form.component.html'
})
export class RoadOccupationFormComponent {

  @Input()
  public workPurposeControlType: WorkPurposeControlType = 'select';

  @Input()
  public purposeControlType: PurposeControlType = 'input';

  @Input()
  public form: RoadOccupationForm | undefined;

  public serviceId: InputSignal<string | null> = input<string | null>(null);

  public applicationId: InputSignal<string | null> = input<string | null>(null);

  public roadOccupationTypes: Signal<RoadOccupationTypeAppEntityDictionaryRoadOccupationType[]> = this.store$.selectSignal(selectRoadOccupationTypes);

  public purposeFeeCollection: Signal<RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee[]> = this.store$.selectSignal(selectPurposeFeeCollection);

  constructor(private store$: Store) {
  }

}
